import { Flex, Group } from '@mantine/core';
import { FC, memo } from 'react';
import { Button } from 'src/components/Button';

type Props = {
  showSubmitButton?: boolean;

  onCancel?: () => void;
  onDelete?: () => void;
  onEdit?: () => void;

  submitButton?: string;
  cancelButton?: string;
  deleteButton?: string;
  editButton?: string;

  isLoading?: boolean;
};

export const ActionFooter: FC<Props> = memo(
  ({
    showSubmitButton = true,
    onCancel,
    onDelete,
    onEdit,

    submitButton = 'SAVE',
    cancelButton = 'CANCEL',
    deleteButton = 'DELETE',
    editButton = 'EDIT',

    isLoading = false,
  }) => {
    return (
      <Flex direction="column" justify="flex-end" mt="xl">
        <Flex justify="space-between">
          {onCancel && (
            <Button
              type="button"
              round
              variant="outline"
              onClick={onCancel}
              disabled={isLoading}
            >
              {cancelButton}
            </Button>
          )}

          <Group>
            {onEdit && (
              <Button
                type="button"
                round
                variant="outline"
                onClick={onEdit}
                disabled={isLoading}
              >
                {editButton}
              </Button>
            )}
            {onDelete && (
              <Button
                type="button"
                round
                variant="danger"
                loading={isLoading}
                onClick={onDelete}
                disabled={isLoading}
              >
                {deleteButton}
              </Button>
            )}
            {showSubmitButton && (
              <Button type="submit" round variant="filled" loading={isLoading}>
                {submitButton}
              </Button>
            )}
          </Group>
        </Flex>
      </Flex>
    );
  }
);

ActionFooter.displayName = 'ActionFooter';
